import styled from "styled-components";
import { pxToRem } from "../../styles/utils";


export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: radial-gradient(
      51% 51% at 50% 121%,
      rgba(131, 102, 228, 0.6),
      rgba(131, 102, 228, 0)
    ),
    rgb(247, 248, 248);
`;

export const Content = styled.div`
  max-width: ${pxToRem(600)};
  padding: ${pxToRem(20)};
`;

export const ErrorCode = styled.h1`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(290)};
  font-weight: 600;
  line-height: 1;
`;

export const ErrorMessage = styled.p`
  color: rgb(31, 10, 53);
  font-family: Inter, sans-serif;
  font-size: ${pxToRem(48)};
  font-weight: 600;
  margin-bottom: ${pxToRem(43)};
`;

export const HomeLink = styled.a`
  border: ${pxToRem(1)} solid rgb(114, 82, 220);
  border-radius: ${pxToRem(12)};
  padding: ${pxToRem(14)} ${pxToRem(28)};
  color: rgb(114, 82, 220);
  text-decoration: none;
  font-size: ${pxToRem(18)};
  font-weight: 600;

  &:hover {
    border-radius: ${pxToRem(12)};
    background: rgb(144, 112, 245);
    color: white;
  }
`;
